<div fxLayout="row">
  <div fxFlex="0 0 48px" fxLayout="row" fxLayoutAlign="center start">
    <a [routerLink]="account.url">
      <app-avatar-account [item]="account" class="u-display-block">
      </app-avatar-account>
    </a>
  </div>
  <div fxFlex="0 0 calc(100% - 48px)" class="text-body-2">
    <a [routerLink]="account.url">
      <b>{{ account | appAccountFullName }}</b>
      <ng-container *ngIf="isUser">
        <span i18n="@@feedItem.accountInfoLabel" class="color-grey-300"
          >&nbsp;(You)</span
        >
      </ng-container>
      <span
        *ngIf="(account | appDisplayUserPronouns) && !isUser"
        class="color-grey-300 text-body-2"
      >
        {{ account | appDisplayUserPronouns }}</span
      >
    </a>
    <div class="color-grey-300">
      <div *ngIf="account?.job_title">{{ account?.job_title }}</div>
      <div *ngIf="account?.organization_name">
        {{ account?.organization_name }}
      </div>
    </div>
  </div>
</div>
